<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-01-09 16:39:34
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-01-09 16:53:11
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/wemeet-poster/src/views/poster/qrCodeByIconByName.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div>
    <div class="box">
      <p style="font-size:40px;color:#262626;font-weight:bold;padding-top: 30px;">{{name}}</p>
      <div style="font-size:30px;color:#262626;margin-top:20px;padding:0 60px;" class="text-ellipsis-2">{{company}}</div>
      <img :src='qrCodeUrl' class="qrcode"></img>
      <img :src='logo' class="logo" v-if="logo"></img>
    </div>

    <div id='DONE' v-if="complete"></div>

  </div>
</template>

<script>
import { GetQueryString, loadImageEnd } from '@/utils/utils'
export default {
  name: 'qrCodeByIconByName',
  data() {
    return {
      qrCodeUrl: '',
      logo: '',
      complete: false,
      name: '',
      company: '',
    }
  },

  mounted() {
    this.logo = decodeURIComponent(GetQueryString('logo')) || ''
    this.qrCodeUrl = decodeURIComponent(GetQueryString('qrCodeUrl'))
    this.name = decodeURIComponent(GetQueryString('name'))
    this.company = decodeURIComponent(GetQueryString('company'))
    let allImg = [this.qrCodeUrl, this.logo]
    loadImageEnd(allImg, () => {
      console.log('图片加载完毕')
      this.complete = true
    })
  },

  methods: {},
}
</script>

<style lang="less" scoped>
.box {
  width: 750px;
  height: 920px;
  text-align: center;
  background: #ffffff;
  .qrcode {
    width: 600px;
    height: 600px;
    margin: 40px auto 0;
  }
  .logo {
    width: 289px;
    height: 70px;
    margin: 0 auto;
  }
}
.text-ellipsis-2{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-all;
  overflow: hidden;
}
</style>